<template>
  <Row style="padding: 20px" gutter="10">
    <Col span="24">
      <Row gutter="10">
        <Col span="20">
          <Row gutter="10">
            <Col span="4">
              <Select v-model="model11" filterable placeholder="">
                <Option value="0">禁用中</Option>
                <Option value="1">启用中</Option>
                <Option value="2">待开通</Option>
                <Option value="3">全部状态</Option>
              </Select>
            </Col>
            <Col span="4">
              <Input v-model="model11" placeholder="门店名称/门店编码/门店码/ERP编码/登陆账号/店主手机号/店主名称"></Input>
            </Col>
            <Col span="4">
              <Select v-model="model11" filterable placeholder="请选择资金商">
                <!-- <Option :value="item.value" :key="item.value">{{ item.label }}</Option> -->
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="model11" filterable placeholder="请选择服务商">
                <!-- <Option :value="item.value" :key="item.value">{{ item.label }}</Option> -->
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="model11" filterable placeholder="请选择资金商">
                <!-- <Option :value="item.value" :key="item.value">{{ item.label }}</Option> -->
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="model11" filterable placeholder="请选择资金商">
                <!-- <Option :value="item.value" :key="item.value">{{ item.label }}</Option> -->
              </Select>
            </Col>
          </Row>
          <Row gutter="10" style="margin-top: 10px">
            <Col span="4">
              <Select v-model="model11" filterable placeholder="请选择资金商">
                <!-- <Option :value="item.value" :key="item.value">{{ item.label }}</Option> -->
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="model11" filterable placeholder="请选择资金商">
                <!-- <Option :value="item.value" :key="item.value">{{ item.label }}</Option> -->
              </Select>
            </Col>
            <Col span="4">
              <Input placeholder="请输入"></Input>
            </Col>
            <Col span="4">
              <Input placeholder="请输入"></Input>
            </Col>
            <Col span="4">
              <Input placeholder="请输入"></Input>
            </Col>
            <Col span="4">
              <Input placeholder="请输入"></Input>
            </Col>
          </Row>
          <Row gutter="10" style="margin-top: 10px">
            <Col span="4">
              <Input placeholder="请输入"></Input>
            </Col>
            <Col span="4">
              <Input placeholder="请输入"></Input>
            </Col>
            <Col span="4">
              <Input placeholder="请输入"></Input>
            </Col>
          </Row>
        </Col>
        <Col span="4">
          <Button type="primary" @click="getList">搜索</Button>
          <Button @click="resetList">重置</Button>
        </Col>
      </Row>
    </Col>
    <Col span="24">
      <Button type="primary" icon="md-add" class="add" @click="create"
        >添加</Button
      >
      <Button
        type="primary"
        icon="md-cloud-download"
        class="add"
        @click="importHandler"
        >导入</Button
      >
      <Button
        type="primary"
        icon="md-cloud-upload"
        class="add"
        @click="exportHandler"
        >导出</Button
      >
    </Col>
    <Col span="24">
      <Table
        class="table"
        border
        stripe
        :loading="loading"
        :columns="columns"
        :data="shopInfoQueryList.data || []"
      >
        <template slot-scope="{ row, index }" slot="no">
          <span>{{ params.pageSize * (params.pageNum - 1) + index + 1 }}</span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a style="margin-right: 5px" @click="detail(row, index)">查看</a>
          <a
            type="text"
            size="small"
            style="margin-right: 5px"
            @click="edit(row, index)"
            >编辑</a
          >
        </template>
      </Table>
      <Page
        :style="{ float: 'right', marginTop: '10px' }"
        :total="shopInfoQueryList.total"
        show-sizer
        show-total
        prev-text="Previous"
        next-text="Next"
        show-elevator
        @on-change="pageNumChange"
        @on-page-size-change="pageSizeChange"
      />
    </Col>
  </Row>
</template>
<script>
import { mapGetters } from "vuex";
// tabler columns
import columns from "./columns.json";
export default {
  data() {
    return {
      loading: false,
      columns,
      params: {
        pageSize: 10,
        pageNum: 1,
        searchName: "",
        businessMobile: "string",
        contactMobile: "string",
        contractPerson: "string",
        dealerCode: "string",
        lati: 0,
        longi: 0,
        refereeCode: "string",
        retType: "string",
        serviceCode: "string",
        shopHeadImg: "string",
        shopInImg: "string",
        shopNumImg: "string",
        storeAddress: "string",
        storeArea: "string",
        storeClass: "string",
        storeName: "string",
        zipCode: "string",
      },
    };
  },
  computed: {
    ...mapGetters({
      shopInfoQueryList: "merchant/getShopInfoQueryList",
    }),
  },
  created() {
    this.getList();

    // setTimeout(() => {
    //   console.log(this.shopInfoQueryList)
    // }, 2000)
  },
  methods: {
    // 列表
    getList() {
      this.loading = true;
      this.$store
        .dispatch("merchant/shopInfoQueryList", this.params)
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 页码
    pageNumChange(pageNum) {
      this.params.pageNum = pageNum;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize) {
      this.params.pageSize = pageSize;
      // 页码变动触发pageNumChange
      if (this.params.pageNum == 1) {
        this.getList();
      } else {
        this.params.pageNum = 1;
      }
    },
    // 重置
    resetList() {
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.params.searchName = "";
      this.getList();
    },
    // 添加
    create() {
      this.$router.push({
        path: "create",
        // query:
      });
    },
    // 导入
    importHandler() {},
    // 导出
    exportHandler() {},
    // 详情
    detail(row, index) {
      this.$router.push({
        path: "detail",
        query: {
          code: row.code,
        },
      });
    },
    // 编辑
    edit(row, index) {
      this.$router.push({
        path: "create",
        query: {
          code: row.code,
        },
      });
    },
  },
};
</script>
<style scoped>
.search {
  margin-right: 15px;
  width: 300px;
}
.add {
  float: right;
  margin-right: 0;
  margin-left: 15px;
}
.table {
  margin-top: 10px;
}
.formEach {
  display: flex;
  margin-bottom: 10px;
  position: relative;
  padding-left: 20px;
}
.formEach > span {
  line-height: 30px;
  width: 80px;
}
.formEach > span::before {
  content: "*";
  color: brown;
}
.formEach > .noq::before {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/shop/info/index.vue